function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, color, spacing, transition, font } from "../../styles/theme";
import Paper from "./Paper"; // you should be able to import this from src but for some reason it fails that way

var CONFIG = {
  cardPadding: spacing.md,
  subtitleColor: color.secondaryText,
  subtitleVerticalPadding: '0',
  headerVerticalPadding: spacing.sm,
  footerVerticalPadding: spacing.sm,
  darkThemeBackground: color.black,
  titleMarginTop: spacing.xs
};
var styles = StyleSheet.create({
  Card: {
    width: '100%',
    transition: transition.easeOut(),
    position: 'relative'
  },
  cardDarkTheme: {
    color: color.white,
    backgroundColor: CONFIG.darkThemeBackground
  },
  darkThemePrimaryText: {
    color: color.white
  },
  darkThemeSecondaryText: {
    color: color.secondaryTextThemeDark
  },
  cardBorder: {
    border: "1px solid ".concat(color.divider)
  },
  cardPadding: {
    padding: CONFIG.cardPadding
  },
  CardBlock: {
    padding: CONFIG.cardPadding
  },
  fullBleed: {
    padding: 0,
    margin: 0
  },
  clearFix: {
    ':after': {
      content: '',
      display: 'table',
      clear: 'both'
    }
  },
  CardTitle: {
    marginTop: CONFIG.titleMarginTop
  },
  cardTitleHeading: {
    paddingTop: CONFIG.cardPadding,
    paddingLeft: CONFIG.cardPadding,
    paddingRight: CONFIG.cardPadding
  },
  CardSubtitle: {
    color: CONFIG.subtitleColor
  },
  cardSubtitleHeading: {
    padding: "".concat(CONFIG.subtitleVerticalPadding, " ").concat(CONFIG.cardPadding),
    marginBottom: 0
  },
  CardHeader: {
    backgroundColor: '#f5f5f5',
    borderBottom: "1px solid ".concat(color.divider)
  },
  cardHeaderText: {
    padding: "".concat(CONFIG.headerVerticalPadding, " ").concat(CONFIG.cardPadding),
    marginBottom: 0
  },
  CardFooter: {
    backgroundColor: '#f5f5f5',
    borderTop: "1px solid ".concat(color.divider)
  },
  cardFooterText: {
    display: 'block',
    color: color.secondaryText,
    fontSize: font.sm,
    padding: "".concat(CONFIG.footerVerticalPadding, " ").concat(CONFIG.cardPadding),
    marginBottom: 0
  },
  CardImage: {},
  cardImg: {
    width: '100%',
    height: 'auto'
  },
  cardImageOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    padding: '1.25rem'
  }
}); // TODO: object includes Aphrodite style objects. Move this common type
// somewhere global that other components can use.
// TODO: use opaque types when they're available
// TODO(Audrey): add comments and ImageOverlay
// Work with design to figure out theme related colors

export function Card(_ref) {
  var children = _ref.children,
      _ref$htmlAttributes = _ref.htmlAttributes,
      htmlAttributes = _ref$htmlAttributes === void 0 ? {} : _ref$htmlAttributes,
      _ref$tagAttributes = _ref.tagAttributes,
      tagAttributes = _ref$tagAttributes === void 0 ? {} : _ref$tagAttributes,
      _ref$paperStyle = _ref.paperStyle,
      paperStyle = _ref$paperStyle === void 0 ? {} : _ref$paperStyle,
      isThemeDark = _ref.isThemeDark,
      style = _ref.style,
      tag = _ref.tag,
      isCardBlock = _ref.isCardBlock,
      isInteractive = _ref.isInteractive,
      rootClassName = _ref.rootClassName;
  var passThroughProps = isInteractive ? {
    isInteractive: true,
    rootClassName: rootClassName
  } : {};
  var Tag = tag === undefined || tag === null ? Paper : tag;
  return React.createElement(Tag, _extends({
    rootClassName: rootClassName,
    htmlAttributes: htmlAttributes
  }, tagAttributes, passThroughProps, css(rootClassName, styles.Card, Tag !== Paper && styles.cardBorder, isCardBlock && styles.CardBlock, isCardBlock && styles.clearFix, isThemeDark && styles.cardDarkTheme), {
    style: _objectSpread({}, paperStyle, style),
    isThemeDark: isThemeDark
  }), children);
} // Explicity declare the default props for documentation purpose,

Card.defaultProps = {
  htmlAttributes: {},
  style: {},
  tag: Paper
};
Card.propTypes = {
  // Can use to letters inside the avatar.
  children: PropTypes.node,
  htmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  // Extra style props for paper
  paperStyle: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  // The attributes we want to spread for the specific tag
  tagAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  // Whether button has dark bg parent element.
  isThemeDark: PropTypes.bool,
  // Show hover shadow
  isInteractive: PropTypes.bool,
  // Override the inline-styles of the root element.
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  // The root element to render, default to Paper, but also can user other elements.
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  // Apply the card padding if the root element is block.
  isCardBlock: PropTypes.bool,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
export function CardBlock(_ref2) {
  var _ref2$htmlAttributes = _ref2.htmlAttributes,
      htmlAttributes = _ref2$htmlAttributes === void 0 ? {} : _ref2$htmlAttributes,
      style = _ref2.style,
      isThemeDark = _ref2.isThemeDark,
      children = _ref2.children,
      isFullBleed = _ref2.isFullBleed;
  return React.createElement("div", _extends({}, htmlAttributes, css(styles.CardBlock, isFullBleed && styles.fullBleed, isThemeDark && styles.darkThemePrimaryText), {
    style: style
  }), children);
}
CardBlock.propTypes = {
  htmlAttributes: PropTypes.object,
  isFullBleed: PropTypes.bool,
  children: PropTypes.node,
  isThemeDark: PropTypes.bool,
  style: PropTypes.object
};
export function CardTitle(_ref3) {
  var isThemeDark = _ref3.isThemeDark,
      title = _ref3.title,
      _ref3$htmlAttributes = _ref3.htmlAttributes,
      htmlAttributes = _ref3$htmlAttributes === void 0 ? {} : _ref3$htmlAttributes,
      children = _ref3.children;

  if (title) {
    return React.createElement("h3", _extends({}, htmlAttributes, css(styles.CardTitle, styles.cardTitleHeading, isThemeDark && styles.darkThemePrimaryText)), title);
  }

  return React.createElement("div", _extends({}, htmlAttributes, css(styles.CardTitle, styles.clearFix, isThemeDark && styles.darkThemePrimaryText)), children);
}
CardTitle.propTypes = {
  htmlAttributes: PropTypes.object,
  children: PropTypes.node,
  title: PropTypes.string,
  isThemeDark: PropTypes.bool
};
CardTitle.defaultProps = {
  htmlAttributes: {}
};
export function CardSubtitle(_ref4) {
  var isThemeDark = _ref4.isThemeDark,
      subtitle = _ref4.subtitle,
      htmlAttributes = _ref4.htmlAttributes,
      children = _ref4.children;

  if (subtitle) {
    return React.createElement("h5", _extends({}, htmlAttributes, css(styles.CardSubtitle, styles.cardSubtitleHeading, isThemeDark && styles.darkThemePrimaryText)), subtitle);
  }

  return React.createElement("div", css(styles.CardSubtitle, styles.clearfix, isThemeDark && styles.darkThemePrimaryText), children);
}
CardSubtitle.propTypes = {
  htmlAttributes: PropTypes.object,
  children: PropTypes.node,
  subtitle: PropTypes.string,
  isThemeDark: PropTypes.bool
};
CardSubtitle.defaultProps = {
  htmlAttributes: {}
};
export function CardHeader(_ref5) {
  var style = _ref5.style,
      htmlAttributes = _ref5.htmlAttributes,
      isThemeDark = _ref5.isThemeDark,
      text = _ref5.text,
      children = _ref5.children;

  if (text) {
    return React.createElement("h4", _extends({}, htmlAttributes, css(styles.CardHeader, styles.cardHeaderText, isThemeDark && styles.darkThemePrimaryText)), text);
  }

  return React.createElement("div", _extends({}, css(styles.CardHeader, styles.clearFix, isThemeDark && styles.darkThemePrimaryText), {
    style: style
  }), children);
}
CardHeader.propTypes = {
  htmlAttributes: PropTypes.object,
  children: PropTypes.node,
  text: PropTypes.string,
  isThemeDark: PropTypes.bool,
  style: PropTypes.object
};
CardHeader.defaultProps = {
  htmlAttributes: {}
};
export function CardFooter(_ref6) {
  var style = _ref6.style,
      htmlAttributes = _ref6.htmlAttributes,
      isThemeDark = _ref6.isThemeDark,
      text = _ref6.text,
      children = _ref6.children;

  if (text) {
    return React.createElement("span", _extends({}, htmlAttributes, css(styles.CardFooter, styles.cardFooterText, isThemeDark && styles.darkThemePrimaryText)), text);
  }

  return React.createElement("div", _extends({}, css(styles.CardFooter, styles.clearFix), {
    style: style
  }), children);
}
CardFooter.propTypes = {
  htmlAttributes: PropTypes.object,
  children: PropTypes.node,
  text: PropTypes.string,
  isThemeDark: PropTypes.bool,
  style: PropTypes.object
};
CardFooter.defaultProps = {
  htmlAttributes: {}
};
export function CardImage(_ref7) {
  var htmlAttributes = _ref7.htmlAttributes,
      _ref7$style = _ref7.style,
      style = _ref7$style === void 0 ? {} : _ref7$style,
      imgSrc = _ref7.imgSrc,
      children = _ref7.children,
      maxImgHeight = _ref7.maxImgHeight;

  if (imgSrc && !maxImgHeight) {
    return React.createElement("img", _extends({
      src: imgSrc,
      role: "presentation"
    }, htmlAttributes, css(styles.CardImage, styles.cardImg)));
  }

  if (imgSrc && maxImgHeight) {
    return React.createElement("div", {
      className: "CardImage horizontal-box align-items-absolute-center",
      style: _objectSpread({
        maxHeight: maxImgHeight,
        overflow: 'hidden'
      }, style)
    }, React.createElement("img", _extends({
      src: imgSrc,
      role: "presentation"
    }, htmlAttributes, css(styles.CardImage, styles.cardImg))));
  }

  return React.createElement("div", _extends({}, htmlAttributes, css(styles.CardImage)), children);
}
CardImage.propTypes = {
  htmlAttributes: PropTypes.object,
  style: PropTypes.object,
  children: PropTypes.node,
  imgSrc: PropTypes.string.isRequired,
  maxImgHeight: PropTypes.number
};
CardImage.defaultProps = {
  htmlAttributes: {}
};